export default {
    chartOptions: {
        plotOptions: {
            radialBar: {
                size: 50,
                startAngle: -150,
                endAngle: 150,
                hollow: {
                    size: '70%',
                },
                track: {
                    background: "#bfc5cc",
                    strokeWidth: '15%',
                },
                dataLabels: {
                    name: {
                        show: false
                    },
                    value: {
                        offsetY: 7,
                        color: '#99a2ac',
                        fontSize: '2rem'
                    }
                }
            }
        },
        // colors: ['#00db89'],
        colors: ['#74A4F7'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                // gradientToColors: ['#00b5b5'],
                gradientToColors: ['#2979FF'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            },
        },
        stroke: {
            lineCap: 'round'
        },
        chart: {
            sparkline: {
                enabled: true,
            },
            dropShadow: {
                enabled: true,
                blur: 3,
                left: 1,
                top: 1,
                opacity: 0.1
            },
        },
    },
    dashboardReport: {},
    chartReport: [],
}
